export const ROUTE_TWO_FACTOR_AUTHENTICATION = "/authentication/two-factor";
export const ROUTE_HOME = "/";